module.exports = __webpack_public_path__ + "media/images/biennale_logo-d64afd7c86011dfd61e4fad8b57a99a5.svg";